import { render, staticRenderFns } from "./HealthCeremonyDataTable.vue?vue&type=template&id=3fd803e2&scoped=true"
import script from "./HealthCeremonyDataTable.vue?vue&type=script&lang=js"
export * from "./HealthCeremonyDataTable.vue?vue&type=script&lang=js"
import style0 from "./HealthCeremonyDataTable.vue?vue&type=style&index=0&id=3fd803e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd803e2",
  null
  
)

export default component.exports